const CoveoPlaceholderResultsLoader = () => {
	return (
		<div className="insights-breadcrumbs-container grid placeholder">
			<div className="coveo-headless-content-count">
				<p className="placeholder-pulse coveo-placeholder-card-results"></p>
			</div>
			<div className="insights-breadcrumbs insights-breadcrumbs-empty"></div>
		</div>
	);
};

export default CoveoPlaceholderResultsLoader;
